import useRaceConceptAnimation from './useRaceConceptAnimation.hook';
import { StyledRaceConceptAnimation } from './RaceConceptAnimation.styled';
import Sprite from '@/shared/GameComponents/GameObjects/Sprite/Sprite';

export default function RaceConceptAnimation({ concept, isLastCorrect }) {
  const { state, actions } = useRaceConceptAnimation({ concept });

  return (
    <StyledRaceConceptAnimation velocityX={state.velocity?.x}>
      <div className="race">
        {concept.bg && (
          <Sprite
            onClick={actions.onClick}
            spriteId={concept.bg}
            animId="default"
            transform={state.bgTransform}
          />
        )}
        <Sprite
          onClick={actions.onClick}
          spriteId={concept.atlasId || concept.id}
          animId={state.animId}
          onAnimationLastFrame={actions.onAnimationLastFrame}
          transform={state.transform}
          className={isLastCorrect ? 'last-correct' : ''}
        />

        <div className="race-floor"></div>
      </div>
    </StyledRaceConceptAnimation>
  );
}
